import React from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../../../App.css";

const FAQs = () => {
  return (
    <div className="FAQ-container">
      <Typography
        variant="h5"
        component="h1"
        className="mb-10"
        style={{ textAlign: "center", fontSize: "44px", fontWeight: "700" }}
      >
        Frequently Asked Questions
      </Typography>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={12} md={12}>
          <Accordion style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="accordionSummary">
                Can I upgrade myself or do I have to upgrade my entire
                Workspace?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="accordionDetails">
                Simply go to categories, select from the list of service
                experts, view their profile and hire them.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="accordionSummary">
                What payment methods do you accept?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="accordionDetails">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="accordionSummary">
                What is your refund policy?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="accordionDetails">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="accordionSummary">
                Do you offer discounts for nonprofits?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="accordionDetails">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="accordionSummary">
                How am I billed when I add new members to a Workspace?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="accordionDetails">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
};

export default FAQs;
